import { render, staticRenderFns } from "./Switche.vue?vue&type=template&id=77dd4536&scoped=true&"
import script from "./Switche.vue?vue&type=script&lang=js&"
export * from "./Switche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dd4536",
  null
  
)

export default component.exports